<template>
  <footer
    class="default-footer"
    data-cy="page-footer"
  >
    <div
      class="default-footer__section"
      :class="{ 'default-footer__section--full-width': fullWidth }"
    >
      <div class="default-footer__links">
        <a
          :href="link.url"
          class="default-footer__link"
          target="_blank"
          v-for="link in links"
          :key="link.url"
        >
          {{ link.text }}
        </a>
      </div>
      <div
        class="default-footer__logos"
        :class="{ 'default-footer__logos--full-width': fullWidth }"
      >
        <a
          href="https://www.hep-verlag.ch/"
          target="_blank"
          class="default-footer__logo-link"
        >
          <hep-logo class="default-footer__logo-hep" />
        </a>
        <a
          target="_blank"
          href="https://www.ehb.swiss/"
          class="default-footer__logo-link"
          v-if="flavor.showEHB"
        >
          <ehb-logo class="default-footer__logo-ehb" />
        </a>
        <a
          href="https://www.share-fair.ch/"
          target="_blank"
          class="default-footer__logo-link"
        >
          <share-fair-logo class="default-footer__logo-share-fair" />
        </a>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

import { Flavor } from '@/helpers/flavor.stubabble';

export interface Props {
  fullWidth?: boolean;
}

withDefaults(defineProps<Props>(), {
  fullWidth: false,
});

const flavor = Flavor.getFlavor();
const HepLogo = defineAsyncComponent(() => import('@/components/icons/HepLogo.vue'));
const EhbLogo = defineAsyncComponent(() => import('@/components/icons/EhbLogo.vue'));
const ShareFairLogo = defineAsyncComponent(() => import('@/components/icons/ShareFairLogo.vue'));

interface Link {
  url: string;
  text: string;
}

const baseUrl = flavor.baseUrl;

const links: Link[] = [
  { url: `https://${baseUrl}/datenschutz`, text: 'Datenschutz' },
  { url: `https://${baseUrl}/impressum`, text: 'Impressum' },
  { url: `https://${baseUrl}/agb`, text: 'AGB' },
  { url: `https://${baseUrl}/support`, text: 'Support' },
  { url: `https://${baseUrl}/faq`, text: 'FAQ' },
];
</script>

<style scoped lang="postcss">
@import 'styles/css/mixins/typography.css';
@import 'styles/css/mixins/desktop.css';

.default-footer {
  background-color: var(--color-silver-light);
  max-width: 100vw;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  display: flex;
  justify-content: center;

  &__section {
    width: 100%;
    max-width: var(--footer-width);
    padding: var(--large-spacing) 0;
    display: flex;
    justify-content: space-between;
    width: 100%;
    border-bottom: var(--color-silver) 1px solid;
    display: flex;
    box-sizing: border-box;

    &--full-width {
      max-width: none;
      padding: var(--large-spacing);
      flex-direction: row-reverse;
    }
  }

  &__links {
    display: flex;
    flex-direction: column;

    @add-mixin desktop {
      flex-direction: row;
      align-items: center;
    }
  }

  &__link {
    @add-mixin aside-text;
    margin-right: var(--large-spacing);
    margin-bottom: var(--small-spacing);

    @add-mixin desktop {
      margin-bottom: 0;
    }
  }

  &__logos {
    display: flex;
    gap: var(--large-spacing);
  }

  &__logo-ehb {
    width: 100px;
    height: 32px;
    display: flex;
  }

  &__logo-hep {
    display: flex;
  }

  &__logo-share-fair {
    width: 100px;
    height: 48px;
  }
}
</style>
